/* eslint-disable */
export default function getAppColors(lightMood) {
  let moodColors = null;

  if (lightMood) {
    moodColors = {
      scrollBarColor: "#000",
      colorTemplateId: "#000",
      mainBg1Color: "#FFF",
      mainBg2Color: "#FFF",
      sideMenuColor: "#032431",
      secondaryBg1Color: "#F2F2F2",
      secondaryBg2Color: "#DBE2EA",

      secondaryTitleColor: "#E95626",
      uploadSectionBg1Color: "#e5ebf0",
      uploadSectionBg2Color: "#dee5ec",
      backgroundColorForTable: "none",
      borderBottomForTable: "#DBE2EA",
      borderBottomForTableForEntity: "#DBE2EA",
      borderForSpecificSidebar: "#DBE2EA",
      borderIconProfile: "#DBE2EA",

      buttonLinkPaginationBackgroundColor: "#fff",
      buttonLinkPaginationColor: "#022F43",
      buttonActivePaginationLink: "#e95626",

      textColorInTable: "#707070",
      textColorLabel: "#012F3D",
      backgroundInputColorForCreateOrUpdate: "#fff",
      textInConfirmationModal: "#012F3D",
      textBorderInConfirmationModal: "#012F3D",
      textCssMessageForImmed: "#012F3D",
      borderCreateRole: "#DBE2EA",

      mainColor: "#032431",
      iconsLinksNavbar: "#012F3D",
      btnBgColor: "#E95626",
      btnTextColor: "#FFF",
      borderTable: "#DBE2EA",
      inputSearchColor: "#000",
      btnSearchInInput: "#e95626",
      btnSearchBorderColor: "#DBE2EA",

      linkTextColor: "#FFF",
      linkTextColorActive: "#000",
      linkActiveColor: "#012F3D",
      linkActiveBorderColor: "#e95626",
      linkIconColor: "#FFF",

      tabsLinkColorCompetitionTraining: "#fff",
      tabsLinkBackgroundColorCompetitionTraining:
        "linear-gradient(#044D6B, #021A24)",

      iconTablePlusDesign: "#fff",

      borderLeftForEntity: "#225065",
      tableDataColor: "#F2F2F2",
      borderNextButtonTemplate: "#000",

      tabLinkBackgroundColorTemplate: "#fff",
      borderForStartDateAndTime: "#ccc",
      roleNameLabel: "#37A6A2",
      roleNameinput: "#F2F2F2",
      roleTableHeader: "#032431",
      roleTableBody: "#F2F2F2",
      filecontainer: "#E1E8EE",
      questionsbuttons: "#E1E8EE",
      inputBackground: "#FFFFFF",
      inputPlaceholderColor: "#C3C3C3",
      inputColor: "#032431",
    };
  } else {
    moodColors = {
      scrollBarColor: "#E95626",
      colorTemplateId: "#605858",
      sideMenuColor: "#fff",
      mainBg1Color: "#044D6B",
      mainBg2Color: "#021A24",

      secondaryTitleColor: "#707070",
      secondaryBg1Color: "#002634",
      secondaryBg2Color: "#021A24",
      tableDataColor: "#022B3C",
      uploadSectionBg1Color: "#011f2a",
      uploadSectionBg2Color: "#021b26",
      backgroundColorForTable: "none",
      borderBottomForTable: "#003a54",
      borderBottomForTableForEntity: "#003146",
      borderForSpecificSidebar: "#39525C",
      borderIconProfile: "#fff",

      textColorInTable: "#fff",
      textColorLabel: "#fff",
      backgroundInputColorForCreateOrUpdate: "#032431",
      textInConfirmationModal: "#fff",
      textBorderInConfirmationModal: "#e65c00",
      textCssMessageForImmed: "#fff",
      borderCreateRole: "#003a54",

      buttonLinkPaginationBackgroundColor: "#022F43",
      buttonLinkPaginationColor: "#fff",
      buttonActivePaginationLink: "#e95626",

      mainColor: "#FFF",
      iconsLinksNavbar: "#fff",
      btnBgColor: "#E95626",
      btnTextColor: "#FFF",
      borderTable: "none",
      inputSearchColor: "#FFF",
      btnSearchInInput: "transparent",
      btnSearchBorderColor: "#39525C",

      linkTextColor: "#FFF",
      linkTextColorActive: "#FFF",
      linkActiveColor: "#4997a9",
      linkActiveBorderColor: "#e95626",
      linkIconColor: "#FFF",

      tabsLinkColorCompetitionTraining: "#e95626",
      tabsLinkBackgroundColorCompetitionTraining:
        "linear-gradient(#044D6B, #021A24)",

      iconTablePlusDesign: "#000",

      borderLeftForEntity: "#fff",
      borderNextButtonTemplate: "#e95626",

      tabLinkBackgroundColorTemplate: "linear-gradient(#044D6B, #021A24)",
      borderForStartDateAndTime: "#fff",
      roleNameLabel: "#575756",
      roleNameinput: "#fff",
      roleTableHeader: "#37A6A2",
      roleTableBody: "#032431",
      filecontainer: "#022B3C",
      questionsbuttons: "#003A52",
      inputBackground: "#023144",
      inputPlaceholderColor: "#ffff",
      inputColor:"#ffff",
    };
  }

  document.documentElement.style.setProperty(
    "--scroll-bar-color",
    moodColors["scrollBarColor"]
  );

  document.documentElement.style.setProperty(
    "--main-bg1-color",
    moodColors["mainBg1Color"]
  );
  document.documentElement.style.setProperty(
    "--main-bg2-color",
    moodColors["mainBg2Color"]
  );
  document.documentElement.style.setProperty(
    "--main-color",
    moodColors["mainColor"]
  );
  document.documentElement.style.setProperty(
    "--link-icons-navbar",
    moodColors["iconsLinksNavbar"]
  );
  document.documentElement.style.setProperty(
    "--side-menu-color",
    moodColors["sideMenuColor"]
  );
  document.documentElement.style.setProperty(
    "--secondary-title-color",
    moodColors["secondaryTitleColor"]
  );

  document.documentElement.style.setProperty(
    "--secondary-bg1-color",
    moodColors["secondaryBg1Color"]
  );
  document.documentElement.style.setProperty(
    "--secondary-bg2-color",
    moodColors["secondaryBg2Color"]
  );
  document.documentElement.style.setProperty(
    "--color-template-id",
    moodColors["colorTemplateId"]
  );

  document.documentElement.style.setProperty(
    "--upload-section-bg1-color",
    moodColors["uploadSectionBg1Color"]
  );
  document.documentElement.style.setProperty(
    "--upload-section-bg2-color",
    moodColors["uploadSectionBg2Color"]
  );
  document.documentElement.style.setProperty(
    "--background-color-data",
    moodColors["backgroundColorForTable"]
  );
  document.documentElement.style.setProperty(
    "--border-color-data-table",
    moodColors["borderBottomForTable"]
  );
  document.documentElement.style.setProperty(
    "--table-color-data",
    moodColors["tableDataColor"]
  );
  document.documentElement.style.setProperty(
    "--border-color-data-table-for-entity",
    moodColors["borderBottomForTableForEntity"]
  );
  document.documentElement.style.setProperty(
    "--border-color-specific-sidebar",
    moodColors["borderForSpecificSidebar"]
  );
  document.documentElement.style.setProperty(
    "--border-color-data-role",
    moodColors["borderCreateRole"]
  );
  document.documentElement.style.setProperty(
    "--border-color-profile-icon",
    moodColors["borderIconProfile"]
  );

  document.documentElement.style.setProperty(
    "--btn-pagination-background-color",
    moodColors["buttonLinkPaginationBackgroundColor"]
  );
  document.documentElement.style.setProperty(
    "--btn-pagination-color",
    moodColors["buttonLinkPaginationColor"]
  );
  document.documentElement.style.setProperty(
    "--btn-color-active-color",
    moodColors["buttonActivePaginationLink"]
  );

  document.documentElement.style.setProperty(
    "--color-text-in-table",
    moodColors["textColorInTable"]
  );
  document.documentElement.style.setProperty(
    "--color-text-label",
    moodColors["textColorLabel"]
  );
  document.documentElement.style.setProperty(
    "--background-color-input-create",
    moodColors["backgroundInputColorForCreateOrUpdate"]
  );
  document.documentElement.style.setProperty(
    "--text-color-in-confirmation-modal",
    moodColors["textInConfirmationModal"]
  );
  document.documentElement.style.setProperty(
    "--text-color-in-Confirm-immed",
    moodColors["textCssMessageForImmed"]
  );
  document.documentElement.style.setProperty(
    "--text-border-color-in-confirmation-modal",
    moodColors["textBorderInConfirmationModal"]
  );

  document.documentElement.style.setProperty(
    "--btn-bg-color",
    moodColors["btnBgColor"]
  );
  document.documentElement.style.setProperty(
    "--btn-text-color",
    moodColors["btnTextColor"]
  );
  document.documentElement.style.setProperty(
    "--table-border",
    moodColors["borderTable"]
  );
  document.documentElement.style.setProperty(
    "--input-search-color",
    moodColors["inputSearchColor"]
  );
  document.documentElement.style.setProperty(
    "--btn-search-color",
    moodColors["btnSearchInInput"]
  );
  document.documentElement.style.setProperty(
    "--border-input-color-search",
    moodColors["btnSearchBorderColor"]
  );

  document.documentElement.style.setProperty(
    "--link-text-color",
    moodColors["linkTextColor"]
  );
  document.documentElement.style.setProperty(
    "--link-text-color-active",
    moodColors["linkTextColorActive"]
  );
  document.documentElement.style.setProperty(
    "--link-active-color",
    moodColors["linkActiveColor"]
  );
  document.documentElement.style.setProperty(
    "--link-active-border-color",
    moodColors["linkActiveBorderColor"]
  );
  document.documentElement.style.setProperty(
    "--link-icon-color",
    moodColors["linkIconColor"]
  );

  document.documentElement.style.setProperty(
    "--tab-color-competition-training",
    moodColors["tabsLinkColorCompetitionTraining"]
  );
  document.documentElement.style.setProperty(
    "--tab-background-color-competition-training",
    moodColors["tabsLinkBackgroundColorCompetitionTraining"]
  );

  document.documentElement.style.setProperty(
    "--icon-plus-desgin-table",
    moodColors["iconTablePlusDesign"]
  );

  document.documentElement.style.setProperty(
    "--border-left-entity",
    moodColors["borderLeftForEntity"]
  );

  document.documentElement.style.setProperty(
    "--border-next-btn-template",
    moodColors["borderNextButtonTemplate"]
  );

  document.documentElement.style.setProperty(
    "--tab-color-link-in-template",
    moodColors["tabLinkColorTemplate"]
  );
  document.documentElement.style.setProperty(
    "--tab-background-color-link-in-template",
    moodColors["tabLinkBackgroundColorTemplate"]
  );
  document.documentElement.style.setProperty(
    "--tab-color-active-link-in-template",
    moodColors["tabLinkBackgroundColorTemplateActive"]
  );
  document.documentElement.style.setProperty(
    "--tab-border-start-time-end-time",
    moodColors["borderForStartDateAndTime"]
  );
  document.documentElement.style.setProperty(
    "--roleName-label-color",
    moodColors["roleNameLabel"]
  );
  document.documentElement.style.setProperty(
    "--roleName-input-color",
    moodColors["roleNameinput"]
  );
  document.documentElement.style.setProperty(
    "--roleTable-header-background",
    moodColors["roleTableHeader"]
  );
  document.documentElement.style.setProperty(
    "--roleTable-body-background",
    moodColors["roleTableBody"]
  );
  document.documentElement.style.setProperty(
    "--file-container-background",
    moodColors["filecontainer"]
  );
  document.documentElement.style.setProperty(
    "--question-button-background",
    moodColors["questionsbuttons"]
  );
  document.documentElement.style.setProperty(
    "--input-background",
    moodColors["inputBackground"]
  );
  document.documentElement.style.setProperty(
    "--input-placeholder-color",
    moodColors["inputPlaceholderColor"]
  );
  document.documentElement.style.setProperty(
    "--input-color",
    moodColors["inputColor"]
  );
  return moodColors;
}
